import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_shipping_containers_grid_ComponentContextService } from './FootprintManager.shipping_containers_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { ShippingContainers_shipping_container_dates_dd_singleComponent } from './ShippingContainers.shipping_container_dates_dd_single.component'


interface IFootprintManager_shipping_containers_gridComponentEntity {
  Id?: number, BillOfLading?: string, BondNumber?: string, CarrierId?: number, CarrierServiceTypeId?: number, CommodityDescription?: string, ConsigneeContactId?: number, ContainerNumber?: string, ContainerSizeId?: number, ContainerTypeId?: number, ContainsPortalVisibleAttachments?: boolean, CreatedSysDateTime?: string, CreatedSysUser?: string, CustomsReleaseNumber?: string, DeclaredValue?: number, DeclaredValueCurrencyId?: number, Deleted?: boolean, DimensionUomId?: number, EstimatedDeliveryDateTime?: string, FreightClassId?: number, Height?: number, InventoryMeasurementUnitId?: number, Length?: number, LookupCode?: string, ManifestedPackageBundleCode?: string, ManifestedPackageCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, NmfcNumber?: string, NmfcSubNumber?: string, Notes?: string, OrderTypeId?: number, PackagedItemCount?: number, ParentId?: number, SailOnBoard?: string, SealId?: string, ShipmentId?: number, ShipperContactId?: number, ShippingCost?: number, ShippingCurrencyId?: number, ShippingDate?: string, ShippingManifestId?: number, TrackingNumber?: string, TrailerNumber?: string, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, LicensePlates?: { Id?: number, LookupCode?: string, WarehouseId?: number, Warehouse?: { Name?: string } }[], Shipment?: { Id?: number, ActualWarehouseId?: number, ExpectedWarehouseId?: number, LoadContainerId?: number, LookupCode?: string, StatusId?: number, TypeId?: number, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string, ProjectId?: number, Project?: { Name?: string, OwnerId?: number, Owner?: { Name?: string } } } }[], ActualWarehouse?: { Name?: string }, ExpectedWarehouse?: { Name?: string }, LoadContainer?: { LookupCode?: string }, Status?: { Name?: string } }, TasksForActualSourceShippingContainer?: { CompletedDateTime?: string }[]}

interface IFootprintManager_shipping_containers_gridComponentInParams {
  ownerIds?: number[], projectIds?: number[], warehouseIds?: number[], orderTypeIds?: number[], shipmentStatuses?: number[]}


class FootprintManager_shipping_containers_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_shipping_containers_gridComponent;
  entity: IFootprintManager_shipping_containers_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    ContainsPortalVisibleAttachments_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    Deleted_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    LookupCode: null,
    OrderType: null,
    Warehouse_Name: null,
    Owner_Name: null,
    Project_Name: null,
    Status: null,
    Order_LookupCode: null,
    LoadContainer: null,
    PackVerificationDate: null,
    BillOfLading: null,
    TrackingNumber: null,
    SealId: null,
    ContainerNumber: null,
    ContainsPortalVisibleAttachments: null,
    CustomsReleaseNumber: null,
    DeclaredValue: null,
    Deleted: null,
    EstimatedDeliveryDateTime: null,
    Height: null,
    Length: null,
    Width: null,
    Volume: null,
    Weight: null,
    NmfcNumber: null,
    NmfcSubNumber: null,
    Notes: null,
    PackagedItemCount: null,
    SailOnBoard: null,
    ShippingCost: null,
    ShippingDate: null,
    TrailerNumber: null,
    CreatedSysDateTime: null,
    CreatedSysUser: null,
    ModifiedSysDateTime: null,
    ModifiedSysUser: null,
  }



  constructor(
    grid: FootprintManager_shipping_containers_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_shipping_containers_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.LookupCode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.OrderType = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.OrderType,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Warehouse_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Warehouse_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Owner_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Owner_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Project_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Project_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Order_LookupCode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Order_LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LoadContainer = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.LoadContainer,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PackVerificationDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PackVerificationDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.BillOfLading = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.BillOfLading,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.TrackingNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.TrackingNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.SealId = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.SealId,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ContainerNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ContainerNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ContainsPortalVisibleAttachments = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ContainsPortalVisibleAttachments,
      new CheckBoxModel(this.formGroup.controls['ContainsPortalVisibleAttachments_display'] as DatexFormControl, null, true, false, '', null)
,
null
      );
    
    this.cells.CustomsReleaseNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CustomsReleaseNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.DeclaredValue = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.DeclaredValue,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Deleted = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Deleted,
      new CheckBoxModel(this.formGroup.controls['Deleted_display'] as DatexFormControl, null, true, false, '', null)
,
null
      );
    
    this.cells.EstimatedDeliveryDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.EstimatedDeliveryDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Height,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Length = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Length,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Width = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Width,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Volume,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Weight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.NmfcNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.NmfcNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.NmfcSubNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.NmfcSubNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PackagedItemCount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PackagedItemCount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.SailOnBoard = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.SailOnBoard,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ShippingCost = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ShippingCost,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ShippingDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ShippingDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.TrailerNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.TrailerNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CreatedSysDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CreatedSysDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CreatedSysUser = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CreatedSysUser,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ModifiedSysDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ModifiedSysDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ModifiedSysUser = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ModifiedSysUser,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_shipping_containers_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_shipping_containers_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      orderTypeIds:  $grid.inParams.orderTypeIds ,
      warehouseIds:  $grid.inParams.warehouseIds ,
      shipmentIds:  null ,
      dateFrom:  $grid.filters.date_from.control.value ,
      dateTo:  $grid.filters.date_to.control.value ,
      dateType:  $grid.filters.date_type.control.value ,
      ownerIds:  $grid.inParams.ownerIds ,
      projectIds:  $grid.inParams.projectIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      shipmentStatuses:  $grid.inParams.shipmentStatuses ,
    };
    const data = await this.$datasources.ShippingContainers.ds_shipping_containers_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_shipping_containers_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.LookupCode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.Warehouse_Name.displayControl as TextModel).text = $row.entity.Shipment?.ExpectedWarehouse?.Name;
    (this.cells.Owner_Name.displayControl as TextModel).text = $row.entity.Shipment?.OrderLookups[0]?.Order?.Project?.Owner?.Name;
    (this.cells.Project_Name.displayControl as TextModel).text = $row.entity.Shipment?.OrderLookups[0]?.Order?.Project?.Name;
    (this.cells.Status.displayControl as TextModel).text = $row.entity.Shipment?.Status.Name;
    (this.cells.Order_LookupCode.displayControl as TextModel).text = $row.entity.Shipment?.OrderLookups[0]?.Order?.LookupCode;
    (this.cells.LoadContainer.displayControl as TextModel).text = $row.entity.Shipment?.LoadContainer?.LookupCode;
    (this.cells.BillOfLading.displayControl as TextModel).text = $row.entity.BillOfLading;
    (this.cells.TrackingNumber.displayControl as TextModel).text = $row.entity.TrackingNumber;
    (this.cells.SealId.displayControl as TextModel).text = $row.entity.SealId;
    (this.cells.ContainerNumber.displayControl as TextModel).text = $row.entity.ContainerNumber;
    (this.cells.ContainsPortalVisibleAttachments.displayControl as CheckBoxModel).reset($row.entity.ContainsPortalVisibleAttachments);
    (this.cells.CustomsReleaseNumber.displayControl as TextModel).text = $row.entity.CustomsReleaseNumber;
    (this.cells.DeclaredValue.displayControl as TextModel).text = $row.entity.DeclaredValue?.toString();
    (this.cells.Deleted.displayControl as CheckBoxModel).reset($row.entity.Deleted);
    (this.cells.Height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.Length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.Width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.Volume.displayControl as TextModel).text = $row.entity.Volume?.toString();
    (this.cells.Weight.displayControl as TextModel).text = $row.entity.Weight?.toString();
    (this.cells.NmfcNumber.displayControl as TextModel).text = $row.entity.NmfcNumber;
    (this.cells.NmfcSubNumber.displayControl as TextModel).text = $row.entity.NmfcSubNumber;
    (this.cells.Notes.displayControl as TextModel).text = $row.entity.Notes;
    (this.cells.PackagedItemCount.displayControl as TextModel).text = $row.entity.PackagedItemCount?.toString();
    (this.cells.ShippingCost.displayControl as TextModel).text = $row.entity.ShippingCost?.toString();
    (this.cells.TrailerNumber.displayControl as TextModel).text = $row.entity.TrailerNumber;
    (this.cells.CreatedSysUser.displayControl as TextModel).text = $row.entity.CreatedSysUser;
    (this.cells.ModifiedSysUser.displayControl as TextModel).text = $row.entity.ModifiedSysUser;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'LookupCode' : {
        this.on_lookup_code_clicked();
        break;
      }
      case 'Order_LookupCode' : {
        this.on_order_clicked();
        break;
      }
      case 'LoadContainer' : {
        this.on_load_container_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_shipping_containers_gridComponentRowModel,
  $grid: FootprintManager_shipping_containers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // O.Arias - 09/26/2023
  
  // Set Date/Time Formats
  const format = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  if ($utils.isDefined(format)) {
  
      if ($utils.isDefined($row.entity.EstimatedDeliveryDateTime)) {
          $row.cells.EstimatedDeliveryDateTime.displayControl.text = $utils.date.format($row.entity.EstimatedDeliveryDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.SailOnBoard)) {
          $row.cells.SailOnBoard.displayControl.text = $utils.date.format($row.entity.SailOnBoard, format);
      };
  
      if ($utils.isDefined($row.entity.ShippingDate)) {
          $row.cells.ShippingDate.displayControl.text = $utils.date.format($row.entity.ShippingDate, format);
      };
  
      if ($utils.isDefined($row.entity.CreatedSysDateTime)) {
          $row.cells.CreatedSysDateTime.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.ModifiedSysDateTime)) {
          $row.cells.ModifiedSysDateTime.displayControl.text = $utils.date.format($row.entity.ModifiedSysDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.TasksForActualSourceShippingContainer[0]?.CompletedDateTime)) {
          $row.cells.PackVerificationDate.displayControl.text = $utils.date.format($row.entity.TasksForActualSourceShippingContainer[0]?.CompletedDateTime, format);
      };
  
  };
  
  let order_type = $row.entity.OrderTypeId;
  
  if ($utils.isDefined($row.entity.Shipment?.TypeId)) {
      order_type = $row.entity.Shipment?.TypeId;
  };
  
  if ($utils.isDefined(order_type)) {
  
      if (order_type === 1) {
          $row.cells.OrderType.displayControl.text = 'Inbound'
      } else {
          $row.cells.OrderType.displayControl.text = 'Outbound'
      };
  };
  }
  on_lookup_code_clicked(event = null) {
    return this.on_lookup_code_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookup_code_clickedInternal(
    $row: FootprintManager_shipping_containers_gridComponentRowModel,
  $grid: FootprintManager_shipping_containers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $shell.FootprintManager.openshipping_container_editor({ shippingContainerId: $row.entity.Id });
  }
  on_load_container_clicked(event = null) {
    return this.on_load_container_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_load_container_clickedInternal(
    $row: FootprintManager_shipping_containers_gridComponentRowModel,
  $grid: FootprintManager_shipping_containers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.Shipment?.LoadContainerId)) {
          $shell.FootprintManager.openload_container_editor({ loadContainerId: $row.entity.Shipment.LoadContainerId });
  };
  }
  on_order_clicked(event = null) {
    return this.on_order_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_order_clickedInternal(
    $row: FootprintManager_shipping_containers_gridComponentRowModel,
  $grid: FootprintManager_shipping_containers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.Shipment?.OrderLookups[0]?.OrderId)) {
      let orderId = $row.entity.Shipment.OrderLookups[0].OrderId
      let order = (await $datasources.AsnOrders.ds_asn_order_editor.get({ orderId: orderId })).result;
      let order_class = -1;
  
      if ($utils.isDefined(order)) {
          order_class = order.OrderClassId;
      };
  
      if (order_class === 1) {
          $shell.FootprintManager.openpurchase_order_editor({ orderId: orderId });
      } else if (order_class === 14) {
          $shell.FootprintManager.openasn_order_editor({ order_id: orderId });
      } else {
          $shell.FootprintManager.opensales_order_editor({ orderId: orderId });
      };
  };
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => ShippingContainers_shipping_container_dates_dd_singleComponent),
  ],
  selector: 'FootprintManager-shipping_containers_grid',
  templateUrl: './FootprintManager.shipping_containers_grid.component.html'
})
export class FootprintManager_shipping_containers_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_shipping_containers_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['default','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_shipping_containers_gridComponentInParams = { ownerIds: [], projectIds: [], warehouseIds: [], orderTypeIds: [], shipmentStatuses: [] };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'LookupCode', 'Container', false, false, null, false),       OrderType: new GridHeaderModel(new HeaderStyles(null, null), 'OrderType', 'Order type', false, false, null, false),       Warehouse_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Warehouse_Name', 'Warehouse', false, false, null, false),       Owner_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Owner_Name', 'Owner', false, false, null, false),       Project_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Project_Name', 'Project', false, false, null, false),       Status: new GridHeaderModel(new HeaderStyles(null, null), 'Status', 'Status', false, false, null, false),       Order_LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'Order_LookupCode', 'Order', false, false, null, false),       LoadContainer: new GridHeaderModel(new HeaderStyles(null, null), 'LoadContainer', 'Load container', false, false, null, false),       PackVerificationDate: new GridHeaderModel(new HeaderStyles(null, null), 'PackVerificationDate', 'Pack verification date', false, false, null, false),       BillOfLading: new GridHeaderModel(new HeaderStyles(null, null), 'BillOfLading', 'Bill of lading', false, false, null, false),       TrackingNumber: new GridHeaderModel(new HeaderStyles(null, null), 'TrackingNumber', 'Tracking number', false, false, null, false),       SealId: new GridHeaderModel(new HeaderStyles(null, null), 'SealId', 'Seal ID', false, false, null, false),       ContainerNumber: new GridHeaderModel(new HeaderStyles(null, null), 'ContainerNumber', 'Container number', false, false, null, false),       ContainsPortalVisibleAttachments: new GridHeaderModel(new HeaderStyles(null, null), 'ContainsPortalVisibleAttachments', 'Attachments', false, false, null, false),       CustomsReleaseNumber: new GridHeaderModel(new HeaderStyles(null, null), 'CustomsReleaseNumber', 'Release number', false, false, null, false),       DeclaredValue: new GridHeaderModel(new HeaderStyles(null, null), 'DeclaredValue', 'Declared value', false, false, null, false),       Deleted: new GridHeaderModel(new HeaderStyles(null, null), 'Deleted', 'Deleted', false, false, null, false),       EstimatedDeliveryDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'EstimatedDeliveryDateTime', 'Estimated delivery', false, false, null, false),       Height: new GridHeaderModel(new HeaderStyles(null, null), 'Height', 'Height', false, false, null, false),       Length: new GridHeaderModel(new HeaderStyles(null, null), 'Length', 'Length', false, false, null, false),       Width: new GridHeaderModel(new HeaderStyles(null, null), 'Width', 'Width', false, false, null, false),       Volume: new GridHeaderModel(new HeaderStyles(null, null), 'Volume', 'Volume', false, false, null, false),       Weight: new GridHeaderModel(new HeaderStyles(null, null), 'Weight', 'Weight', false, false, null, false),       NmfcNumber: new GridHeaderModel(new HeaderStyles(null, null), 'NmfcNumber', 'Nmfc number', false, false, null, false),       NmfcSubNumber: new GridHeaderModel(new HeaderStyles(null, null), 'NmfcSubNumber', 'Nmfc sub number', false, false, null, false),       Notes: new GridHeaderModel(new HeaderStyles(null, null), 'Notes', 'Notes', false, false, null, false),       PackagedItemCount: new GridHeaderModel(new HeaderStyles(null, null), 'PackagedItemCount', 'Packaged item count', false, false, null, false),       SailOnBoard: new GridHeaderModel(new HeaderStyles(null, null), 'SailOnBoard', 'Sail on board', false, false, null, false),       ShippingCost: new GridHeaderModel(new HeaderStyles(null, null), 'ShippingCost', 'Shipping cost', false, false, null, false),       ShippingDate: new GridHeaderModel(new HeaderStyles(null, null), 'ShippingDate', 'Shipping date', false, false, null, false),       TrailerNumber: new GridHeaderModel(new HeaderStyles(null, null), 'TrailerNumber', 'Trailer number', false, false, null, false),       CreatedSysDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'CreatedSysDateTime', 'Created date', false, false, null, false),       CreatedSysUser: new GridHeaderModel(new HeaderStyles(null, null), 'CreatedSysUser', 'Created by', false, false, null, false),       ModifiedSysDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'ModifiedSysDateTime', 'Modified date', false, false, null, false),       ModifiedSysUser: new GridHeaderModel(new HeaderStyles(null, null), 'ModifiedSysUser', 'Modified by', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_shipping_containers_gridComponentRowModel[] = [];

  @Input('ownerIds') set $inParams_ownerIds(value: any) {
    this.inParams['ownerIds'] = value;
  }
  get $inParams_ownerIds(): any {
    return this.inParams['ownerIds'] ;
  }
  @Input('projectIds') set $inParams_projectIds(value: any) {
    this.inParams['projectIds'] = value;
  }
  get $inParams_projectIds(): any {
    return this.inParams['projectIds'] ;
  }
  @Input('warehouseIds') set $inParams_warehouseIds(value: any) {
    this.inParams['warehouseIds'] = value;
  }
  get $inParams_warehouseIds(): any {
    return this.inParams['warehouseIds'] ;
  }
  @Input('orderTypeIds') set $inParams_orderTypeIds(value: any) {
    this.inParams['orderTypeIds'] = value;
  }
  get $inParams_orderTypeIds(): any {
    return this.inParams['orderTypeIds'] ;
  }
  @Input('shipmentStatuses') set $inParams_shipmentStatuses(value: any) {
    this.inParams['shipmentStatuses'] = value;
  }
  get $inParams_shipmentStatuses(): any {
    return this.inParams['shipmentStatuses'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date from', false, false),
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date to', false, false),
    date_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['date_type'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Date type', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_shipping_containers_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Shipping containers grid';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      orderTypeIds:  $grid.inParams.orderTypeIds ,
      warehouseIds:  $grid.inParams.warehouseIds ,
      shipmentIds:  null ,
      dateFrom:  $grid.filters.date_from.control.value ,
      dateTo:  $grid.filters.date_to.control.value ,
      dateType:  $grid.filters.date_type.control.value ,
      ownerIds:  $grid.inParams.ownerIds ,
      projectIds:  $grid.inParams.projectIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      shipmentStatuses:  $grid.inParams.shipmentStatuses ,
    };
    try {
      const data = await this.$datasources.ShippingContainers.ds_shipping_containers_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_shipping_containers_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_shipping_containers_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_shipping_containers_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }



 
  close() {
    this.$finish.emit();
  }
}
